import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import { Form, Message } from 'semantic-ui-react'
// import _find from 'lodash/find';
// import _ from 'lodash';

// import XLSX from 'xlsx';

//utils
import queries from '../../../utils/queries'
import SeguroPermite from '../../../components/funcionales/seguropermite'
import general from '../../../modulos/general';

import mainRdo from '../../home/functions/recaudo/mainrdo'
// "use strict";

//dropdown TERCEROS
const DetalleNivel1 = props => {
  return (
    <option value={props.elemento.numeroDocum} style={props.styles.input}>{props.elemento.descrRecurso}</option>
  )
};

const ListaTer = ({styles, list, argsDocum, handleChange}) => {
    const Nivel1Detalle = list.map((elemento, i) => <DetalleNivel1 styles={styles} elemento={elemento} key={i} />);
    return(
        <div>
            <select style={styles.input} className="ui simple selection dropdown fluid" name="tercero" id="tercero" onChange={(ev)=>handleChange(ev, argsDocum)}>
                <option style={styles.input} value="">Seleccionar...</option>
                {Nivel1Detalle}
            </select>
        </div>
    )
};
//Fin dropdown TERCEROS

//dropdown OFICINAS
const DetalleOf1 = props => {
  return (
    <option style={props.styles.input}>{props.elemento.descrOficina}</option>
  )
};

const ListaOf = ({styles, list, argsDocum, handleChange}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleOf1 styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="oficina" id="miListaOf" onChange={(ev)=>handleChange(ev, argsDocum)}>
        <option value="">Seleccionar...</option>
        {Nivel1Detalle}
      </select>
    </div>
  )
};
//Fin dropdown OFICINAS

//Clientes
const DetArchProc = ({elemento}) => {
  return(
    <tr className=''>
      <td className=''>{elemento.linea}</td>
      <td className=''>{elemento.contrato}</td>
      <td className='right aligned'>{general.formatNum(elemento.valorTotal.toString())}</td>
    </tr>
  )
};

const ListaArchProc = ({list}) => {
  const nivel1Detalle = list.map((elemento, i) => <DetArchProc elemento={elemento} key={i}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

class ProcCAR2 extends React.Component {
  state={argsDocum: {descrOficina: this.props.descrOficina, numeroDocum: "", descrRecurso: "Seleccionar..."},
    listPagos: [], totPagos: 0,
    permiteUpdate: true, confirmaAct: false, open: false, errors: []}

  handleChange = async (ev, argsDocum) => {
    // console.log(ev.target.name)
    if(ev.target.name==="tercero"||ev.target.name === "oficina"){
      let argsDocumB = argsDocum
      if(ev.target.name==="tercero"){
        let miLista = document.getElementById("tercero");
        argsDocumB['descrRecurso'] = miLista.options[miLista.selectedIndex].text
        argsDocumB['numeroDocum'] = miLista.options[miLista.selectedIndex].value
      }
      if(ev.target.name === "oficina"){
        let miLista = document.getElementById("miListaOf");
        argsDocumB['descrOficina'] = miLista.options[miLista.selectedIndex].text
      }
      this.setState({argsDocum: argsDocumB})
    }else{
      const updState = (listPagos, totPagos) => {
        this.setState({listPagos, errors: [], totPagos})
      };

      if(ev.target.name==="csv"||ev.target.name==="checkTieneEncab"){
        let checkTieneEncab = document.getElementById("checkTieneEncab").checked
        let fileInput = document.getElementById("csv")
        if(fileInput.files.length>0){
          let archcsv = ""
          // console.log(fileInput.files[0].name) //Nombre del archivo seleccionado
          let reader = new FileReader();
          reader.onload = function () {
            archcsv = reader.result
            // document.getElementById('out').innerHTML = archcsv;

            //asignar los datos del archivo a archivo
            let archivo = archcsv.toString()
            //guardar en array lines, cada linea del archivo
            let lines = archivo.split(/\n/)
            let numArch = 0, linea = 0, listPagos = [], totPagos = 0
            lines.forEach(line => {
              if(line&&(numArch>0||(numArch===0&&!checkTieneEncab))){
                linea += 1
                //crear array de campos para cada linea
                let campos = line.split(";")
                let contrato = campos[0]
                let valorTotal = parseInt(campos[1].trim(), 10)
                totPagos += valorTotal
                listPagos.push({linea, contrato, valorTotal})
              }
              numArch += 1
            })
            updState(listPagos, totPagos)
          };
          // start reading the file. When it is done, calls the onload event defined above.
          reader.readAsBinaryString(fileInput.files[0]);
        }else{
          this.setState({listPagos: [], errors: []})
        }
      }
    }
  }

  handleSubmit = async (ev, listPagos)=>{
    let modeloFactura = this.props.empresa.modeloFactura
    let valorparaPermRX = this.props.empresa.valorparaPermRX

    // console.log(modeloFactura, this.state.argsDocum.numeroDocum, this.state.argsDocum.descrRecurso, this.state.argsDocum.descrOficina)
    let errors = []
    if(!this.state.argsDocum.descrRecurso||this.state.argsDocum.descrRecurso==="Seleccionar..."){
      errors.push({path: 'Tercero', message: `Por favor seleccione el Tercero` });
    }
    if(!this.state.argsDocum.descrOficina||this.state.argsDocum.descrOficina==="Todas..."||this.state.argsDocum.descrOficina==="Seleccionar..."){
      errors.push({path: 'Oficina', message: `Por favor seleccione la Oficina` });
    }

    if(listPagos.length===0){
      errors.push({path: "Pagos", message: "No hay pagos"});
    }
    if(modeloFactura==="1"){
      for(let ii=0; ii<listPagos.length; ii++){
        let elemento = listPagos[ii]
        if(!elemento.contrato){
          errors.push({path: "Pagos", message: `Datos inválidos en línea No. ${elemento.linea} => Contrato: ${elemento.contrato}`});
        }
        
        if(this.props.allClientes.allClientes){
          let {data} = await this.props.allClientes.refetch({contrato: listPagos[ii].contrato, numDocum: 1327})
          let allClientes = await data.allClientes
          if(allClientes.length===0){
            errors.push({path: "Pagos", message: `Contrato NO existe en línea No. ${elemento.linea} => Contrato: ${elemento.contrato}`});
          }
        }
      }
    }

    this.setState({errors})
    if(errors.length===0){
      //PROCESO APLICAR PAGOS
      document.body.style.cursor = 'wait'

      //EL ULTIMO CONTRATO NO DEBE TENER NAS DE UN PAGO PORQUE SI TIENE MAS DE UNO,
      //CUANDO ENCUENTRE EL PRIMER PAGO Y LO COMPARE CON contratoFinProc FINALIZA EL PROCESO
      let iii = 0, contratoFinProc = listPagos[listPagos.length-1].contrato, contratoFin = ""

      const startTime = async (listPagos, allCli, allMovCli, allMovCliCC, allRec, allProcFact,
        editSeqfindOneAndUpdate, createPagoClientes, editPagoClientesUpdDoc, createHistClienteMany,
        createMovClientesMany, createMovCliCCMany, editClienteMany, editClienteUpdDocMany,
        editMovClientes, editCliente, editRdoTerc, createAjuste,
        createMovClientes) => {
        let clienteSel = {}, listColeccRP = [], listColeccRPCC = []
        let numeroDocum = this.state.argsDocum.numeroDocum
        let descrRecurso = this.state.argsDocum.descrRecurso
        
        setTimeout(async ()=>{
          // console.log(listPagos[iii])
          if(iii<listPagos.length){
            let response = await this.props.fecha({
              variables: {}
            });
            const {fechaHoraHoy} = response.data.fecha

            let allClientes = []
            if(allCli){
              let {data} = await allCli.refetch({contrato: listPagos[iii].contrato, numDocum: 1327})
              allClientes = await data.allClientes
              clienteSel = allClientes[0]
            }
            // console.log(clienteSel)
            if(clienteSel){
              // console.log(listPagos[iii].contrato, listPagos[iii]._id)
              //CONTRATO EXISTE
              if(allMovCli){
                let {data} = await allMovCli.refetch({contrato: listPagos[iii].contrato, orden: '+_id'})
                let allMovClientes = await data.allMovClientes
                listColeccRP = allMovClientes
                listColeccRP = listColeccRP.filter(elemento => elemento.tipo==="C" && elemento.valorTotal!==elemento.valorPagado)
              }
              if(allMovCliCC){
                let {data} = await allMovCliCC.refetch({contrato: listPagos[iii].contrato, orden: '+_id'})
                let allMovClientesCC = await data.allMovClientesCC
                listColeccRPCC = allMovClientesCC
                listColeccRPCC = listColeccRPCC.filter(elemento => elemento.tipo==="C" && elemento.valorTotal!==elemento.valorPagado)
              }
              let ultMF = ""
              if(allProcFact){
                let ultPF = allProcFact.allProcFact.filter(elemento => elemento.cicloFact===clienteSel.cicloFact)
                if(ultPF.length>0){
                  ultMF = ultPF[ultPF.length-1].mes
                }
              }
// console.log(numeroDocum, descrRecurso)
              contratoFin = await mainRdo(listPagos[iii], clienteSel, listColeccRP, listColeccRPCC,
                numeroDocum, descrRecurso, ultMF, editSeqfindOneAndUpdate, createPagoClientes,
                editPagoClientesUpdDoc, createHistClienteMany, createMovClientesMany, createMovCliCCMany,
                editClienteMany, editClienteUpdDocMany, editMovClientes, editCliente, editRdoTerc,
                createAjuste, createMovClientes, this.state.argsDocum.descrOficina,
                this.props.ajCero, fechaHoraHoy, valorparaPermRX)
            }else{
              if(modeloFactura==="1"){
                alert("El contrato " + listPagos[iii].contrato + " NO EXISTE")
              }else{
                // console.log(iii)
                if(listPagos[iii].contrato===contratoFinProc){
                  // console.log(listPagos[iii].contrato, contratoFinProc)
                  document.body.style.cursor = 'default'
                }

              }
            }

            await startTime(listPagos, allCli, allMovCli, allMovCliCC, allRec, allProcFact,
              editSeqfindOneAndUpdate, createPagoClientes, editPagoClientesUpdDoc, createHistClienteMany,
              createMovClientesMany, createMovCliCCMany, editClienteMany, editClienteUpdDocMany,
              editMovClientes, editCliente, editRdoTerc, createAjuste, createMovClientes)
            // console.log(iii, "contrato ", contratoFin, listPagos[iii].contrato, listPagos[iii].valorTotal, contratoFinProc)
            if(contratoFin===contratoFinProc||(!contratoFinProc&&listPagos.length-iii<=2&&this.props.modeloFactura==="3")){
              document.body.style.cursor = 'default'
              // console.log("timeout fin", iii)
              this.setState({listPagos: [], totPagos: 0, errors: []})
            }
            // console.log(listPagos.length, iii)
            if(listPagos.length===1){
              document.body.style.cursor = 'default'
            }

            iii += 1
          } 
        }, 200);
      }
      await startTime(listPagos, this.props.allClientes, this.props.allMovClientes, this.props.allMovClientesCC,
                      this.props.allRecurso, this.props.allProcFact,
                      this.props.editSeqfindOneAndUpdate, this.props.createPagoClientes,
                      this.props.editPagoClientesUpdDoc, this.props.createHistClienteMany,
                      this.props.createMovClientesMany, this.props.createMovCliCCMany,
                      this.props.editClienteMany, this.props.editClienteUpdDocMany,
                      this.props.editMovClientes, this.props.editCliente, this.props.editRdoTerc,
                      this.props.createAjuste, this.props.createMovClientes)

    }
    console.log("listooooo")
  }

  handleQuestionUpdDel = async (ev) => {
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct){this.setState({open: true})}else{this.setState({open: false, confirmaAct: false})};
    if(btnPress==="No"){
        this.setState({open: false})
    };
    if(btnPress==="Si"){
        this.setState({confirmaAct: true})
        this.setState({open: false})
        const myBtn = await document.getElementById("btnUpdDel");
        myBtn.click()
    }
  }

  async componentDidUpdate(prevProps){

  }

  render(){
    const {argsDocum, listPagos, totPagos, permiteUpdate, confirmaAct, open,
              errors} = this.state;
  
    let mensaje = "APLICAR PAGOS"
    let imgIcon = "images/archivo_32.png"
    let valor = `$${general.formatNum(totPagos.toString())}`

    // let estilos = Object.assign({}, this.props.styles.input, {opacity: 0, cursor: 'pointer'})
    // let estilos = Object.assign({}, this.props.styles.input, {display: "none", cursor: 'pointer'})
    let estilos = Object.assign({}, this.props.styles.input, {cursor: 'pointer'})
    // let estilos = this.props.styles.input
// console.log(this.props.descrOficina, this.props.listaOf, this.props.ajCero, this.props.list7)
    return(
      <div>
        <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
          <i className="large plus yellow icon"></i>
          Procesar archivo
        </button>
        <div>
          <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
            <Form name="form1" id="form1" onSubmit={confirmaAct?(ev)=>this.handleSubmit(ev, listPagos):()=>{}}>
              <div>
                <div className="ui one column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '100%'}}>
                      <h1 style={{color: '#2C7744'}}>Cargar y procesar archivo de recaudo</h1>
                    </div>
                  </div>
                </div>
                <hr></hr>
                <hr></hr>

                <div className="ui two column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '50%'}}>
                      <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                        Tercero
                      </p>
                      <Form.Field>
                        <ListaTer styles={this.props.styles} list={this.props.list7}
                          argsDocum={argsDocum} handleChange={this.handleChange}/>
                      </Form.Field>
                    </div>
                    <div className="column" style={{width: '50%'}}>
                      <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                        Oficina
                      </p>
                      <Form.Field>
                        <ListaOf styles={this.props.styles} list={this.props.listaOf}
                        argsDocum={argsDocum} handleChange={this.handleChange}/>
                      </Form.Field>
                    </div>
                  </div>
                </div>
                <hr></hr>

                <br/>
                <div className="ui two column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '50%'}}>
                      <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                        Seleccionar archivo CSV...&nbsp;&nbsp;
                      </label>

                      <input id="csv" name="csv" type="file" accept=".csv" style={estilos} onChange={this.handleChange}></input>

                      {/* <output id="out" style={estilos1}>
                          file contents will appear here
                      </output> */}
                    </div>
                    <div className="column" style={{width: '50%'}}>
                      <Form.Field>
                        <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'normal', margin: '0.4em 0em 0em 0em'}}>
                          <input style={{margin: '0.4em 0em 0em 0em'}} type='checkbox' id="checkTieneEncab"
                                  name="checkTieneEncab" onChange={this.handleChange}/>
                          &nbsp;&nbsp;Tiene encabezados en la primera fila
                        </p>
                      </Form.Field>
                    </div>

                  </div>
                </div>
                <br/>
                <hr></hr>
                <hr></hr>

                <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                  Totales:  Pagos:&nbsp;
                  {listPagos.length}&nbsp;&nbsp;&nbsp;&nbsp;
                  Valor:&nbsp;
                  {valor}
                </p>

                <div className="ui one column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '100%'}}>
                      <SeguroPermite mensaje={mensaje} imgIcon={imgIcon} permiteUpdate={permiteUpdate} open={open} styles={this.props.styles} handleQuestionUpdDel={this.handleQuestionUpdDel}/>
                    </div>
                  </div>
                </div>
                <hr></hr>

                {
                  errors.length?<Message negative header="No se aplicaron los siguientes pagos:"
                  list={errors.map(error=>`${error.path}: ${error.message}`)} />:null
                }

                <table id="tablaPagos" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                  <thead className=''>
                    <tr className=''>
                    <th className=''>No.</th>  
                    <th className=''>Contrato</th>
                    <th className=''>Valor</th>
                    </tr>
                  </thead>
                  <ListaArchProc list={listPagos}/>
                </table>
              </div>

            </Form>
          </div>
        </div>
      </div>
    )
  }
}

export default compose(
  graphql(queries.query.allClientes, {name:'allClientes', options: (props) => {return {variables: {numDocum: 1}}}}),
  graphql(queries.query.allClientesRtes, {name:'allClientesRtes', options: (props) => {return {variables: {tipoqry: `[{$match: {contrato: "XXXYYYZZZ"}}]`}}}}),
  graphql(queries.query.allMovClientes, {name:'allMovClientes', options: (props) => {return {variables: {contrato: "ABCXYZ", orden: '+_id'}}}}),
  graphql(queries.query.allMovClientesCC, {name:'allMovClientesCC', options: (props) => {return {variables: {contrato: "ABCXYZ", orden: '+_id'}}}}),
  graphql(queries.query.allProcFact, {name:'allProcFact', options: (props) => {return {variables: {}}}}),
  graphql(queries.query.allRecurso, {name:'allRecurso', options: (props) => {return {variables: {numeroDocum: "ABCXYZ"}}}}),

  graphql(queries.mutation.editSeqfindOneAndUpdate, {name:'editSeqfindOneAndUpdate'}),

  graphql(queries.mutation.createPagoClientes, {name:'createPagoClientes'}),
  graphql(queries.mutation.editPagoClientesUpdDoc, {name:'editPagoClientesUpdDoc'}),

  graphql(queries.mutation.createHistClienteMany, {name:'createHistClienteMany'}),

  graphql(queries.mutation.createMovClientesMany, {name:'createMovClientesMany'}),
  graphql(queries.mutation.createMovCliCCMany, {name:'createMovCliCCMany'}),
  graphql(queries.mutation.editClienteMany, {name:'editClienteMany'}),
  graphql(queries.mutation.editClienteUpdDocMany, {name:'editClienteUpdDocMany'}),
  graphql(queries.mutation.editMovClientes, {name:'editMovClientes'}),
  graphql(queries.mutation.createMovClientes, {name:'createMovClientes'}),

  graphql(queries.mutation.editCliente, {name:'editCliente'}),

  graphql(queries.mutation.editRdoTerc, {name:'editRdoTerc'}),

  graphql(queries.mutation.createAjuste, {name:'createAjuste'}),

  graphql(queries.mutation.fecha, {name:'fecha'}),
)(ProcCAR2)
